import { TSupportIssue } from "apiTypes/support";
import { MolhamError } from "components/ReuseableCompos/SharedDonatePages/DonateModal/axiosInstance";
import { NEXT_URL_PROXY } from "config";
import { deleteData } from "utils/deleteData";
import { postData } from "utils/postData";

export const deleteSupportIssue = async (data: { supportIssueId: number }) => {
  try {
    const res = await deleteData(
      `${NEXT_URL_PROXY}/auth/support-issues/${data.supportIssueId}`
    );

    return res as any;
  } catch (err) {
    return err as MolhamError;
  }
};
export const createSupportIssue = async (data: {
  subject: string;
  content: string;
}) => {
  try {
    const res = await postData<TSupportIssue>(
      `${NEXT_URL_PROXY}/support-issues`,
      data
    );

    return res as any;
  } catch (err) {
    return err as MolhamError;
  }
};

export const updateSupportIssue = async (data: {
  subject: string;
  content: string;
  supportIssueId: number;
}) => {
  try {
    const res = await postData<TSupportIssue>(
      `${NEXT_URL_PROXY}/auth/support-issues/${data.supportIssueId}`,
      data
    );

    return res as any;
  } catch (err) {
    return err as MolhamError;
  }
};
export const createReply = async (data: {
  content: string;
  supportIssueId: number;
}) => {
  try {
    const res = await postData<TSupportIssue>(
      `${NEXT_URL_PROXY}/auth/support-issues/${data.supportIssueId}/replies`,
      data
    );

    return res as any;
  } catch (err) {
    return err as MolhamError;
  }
};
export const deleteReply = async (data: {
  supportIssueId: number;
  replyId: number;
}) => {
  try {
    const res = await deleteData(
      `${NEXT_URL_PROXY}/auth/support-issues/${data.supportIssueId}/replies/${data.replyId}`
    );
    return res as any;
  } catch (err) {
    return err as MolhamError;
  }
};

export const updateReply = async (data: {
  content: string;
  supportIssueId: number;
  replyId: number;
}) => {
  try {
    const res = await postData<TSupportIssue>(
      `${NEXT_URL_PROXY}/auth/support-issues/${data.supportIssueId}/replies/${data.replyId}`,
      data
    );

    return res as any;
  } catch (err) {
    return err as MolhamError;
  }
};
